/* ==========================================================================
   Sign-up popup (sections/ivp-popup.liquid, 8 Oct 2026)
   Opens once after data-delay seconds (desktop: also when the pointer leaves through the top of the window, after
   8 s), then not again for data-days days after it was seen. Never after a sign-up (any customer form posted on the
   site, newsletter included), never over an open drawer/menu/search, never while someone is typing in a field.
   After its own sign-up the page returns with #IvpSignupPop and the popup reopens on the thank-you with the code.
   ========================================================================== */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-ivp-pop]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var d = document;
  var KEY = 'ivpPopup';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(read(), o))); } catch (e) {} }
  var editor = dlg.hasAttribute('data-editor');
  var delay = (parseInt(dlg.getAttribute('data-delay'), 10) || 30) * 1000;
  var days = parseInt(dlg.getAttribute('data-days'), 10) || 14;
  var exitOn = dlg.getAttribute('data-exit') === 'true';
  var mobileOn = dlg.getAttribute('data-mobile') !== 'false';

  function open() {
    if (dlg.open) return;
    dlg.showModal();
    d.documentElement.classList.add('ivp-pop-open');
    if (!editor) write({ seen: Date.now() });
  }
  function close() {
    if (!dlg.open) return;
    dlg.close();
  }
  dlg.addEventListener('close', function () { d.documentElement.classList.remove('ivp-pop-open'); });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) { close(); return; } // backdrop
    if (e.target.closest('[data-ivp-pop-close]')) { close(); return; }
    var c = e.target.closest('[data-ivp-copy]');
    if (c && navigator.clipboard) {
      navigator.clipboard.writeText(c.getAttribute('data-ivp-copy')).then(function () {
        var l = c.querySelector('[data-ivp-copy-label]');
        if (l) { l.textContent = 'Copied'; setTimeout(function () { l.textContent = 'Copy'; }, 2000); }
      }, function () {});
    }
  });

  // theme editor: open while the section is selected
  if (editor) {
    var id = dlg.getAttribute('data-section');
    d.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === id) open(); });
    d.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === id) close(); });
    return;
  }

  // any customer form sent (popup, footer newsletter, restock or notify-me: all subscribe) = signed up, never again
  var posted = /[?&]customer_posted=true/.test(window.location.search);
  if (posted) write({ subscribed: true });
  if (window.location.hash === '#IvpSignupPop') {
    if (dlg.querySelector('[data-ivp-pop-done]')) dlg.classList.add('is-done');
    if (dlg.querySelector('[data-ivp-pop-done]') || dlg.querySelector('[data-ivp-pop-err]')) open();
    return;
  }

  var st = read();
  if (st.subscribed) return;
  if (st.seen && Date.now() - st.seen < days * 864e5) return;
  if (!mobileOn && window.matchMedia('(max-width: 749px)').matches) return;

  var start = Date.now();
  function busy() {
    var html = d.documentElement;
    var a = d.activeElement;
    var typing = a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !dlg.contains(a);
    return html.classList.contains('ivp-lock') || !!d.querySelector('.ivp-nav__item.is-open, .is-searching, dialog[open]') || typing || d.hidden;
  }
  function tryOpen() {
    if (busy()) { setTimeout(tryOpen, 8000); return; }
    open();
    d.removeEventListener('mouseout', onLeave);
  }
  var timer = setTimeout(tryOpen, delay);
  function onLeave(e) {
    if (e.relatedTarget || e.clientY > 0 || Date.now() - start < 8000) return;
    clearTimeout(timer);
    tryOpen();
  }
  if (exitOn && window.matchMedia('(pointer: fine)').matches) d.addEventListener('mouseout', onLeave);
})();
